import { Outlet } from 'react-router'
import TopNav from '../components/navigation/TopNav'
import { useSelector } from 'react-redux'
import { pageTitle } from '../features/PageTitleSlice.ts'
import GlobalNotificationModal from '../components/modals/GlobalNotificationModal.tsx'
import Breadcrumbs from '../components/navigation/Breadcrumbs.tsx'
import PaywallBanner from '../components/billing/PaywallBanner.tsx'

export default function AppLayout() {
  const title = useSelector(pageTitle) || (
    <div className="h-10 w-2/3 bg-gray-300 rounded animate-pulse"></div>
  )

  return (
    <div className="min-h-full">
      <TopNav />
      <Breadcrumbs />
      <PaywallBanner />
      <div className="py-10">
        <header>
          <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 custom-max-w-920px">
            <h1 className="text-3xl font-bold leading-tight tracking-tight text-gray-900">
              {title}
            </h1>
          </div>
        </header>
      </div>
      <main>
        <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8 custom-max-w-920px mb-10">
          <Outlet />
        </div>
      </main>
      <GlobalNotificationModal />
    </div>
  )
}
